module.exports = __webpack_public_path__ + "img/advantage4_1@2x.0c76ff6d.png";